import React, { useState } from "react";
import { LazyLoadImage } from "react-lazy-load-image-component";
import FALLBACK from "components/icons/image_icon.svg";
import "./Image.scss";

interface ImageProps {
  className?: string;
  src: string | null | undefined;
  alt?: string | null | undefined;
  width?: string | null | undefined;
  height?: string | null | undefined;
  fallback?: string;
  onFailure?: (url: string) => void;
  lazyLoad?: boolean | null | undefined;
}

export const Image: React.FC<ImageProps> = ({
  className = "",
  src,
  alt,
  width,
  height,
  fallback = FALLBACK,
  onFailure,
  lazyLoad = true,
}) => {
  const [imageSrc, setImageSrc] = useState<string | undefined | null>(src);
  const [loaded, setLoaded] = useState(false);

  const onError = () => {
    console.warn(`Error loading image ${imageSrc} -- showing fallback.`);
    onFailure?.(imageSrc ?? "");
    setImageSrc(fallback);
    setLoaded(true);
  };

  const onLoaded = () => {
    setLoaded(true);
  };

  const style = {
    opacity: loaded ? 1 : 0,
    transition: "opacity 0.1s ease-in-out",
  };

  const dynamicProps = {
    ...(width ? { width } : {}),
    ...(height ? { height } : {}),
  };

  return lazyLoad ? (
    <LazyLoadImage
      wrapperClassName={"Image"}
      className={className}
      effect="opacity"
      src={imageSrc ?? fallback ?? FALLBACK}
      alt={loaded ? alt ?? "" : ""}
      style={style}
      {...dynamicProps}
      onError={onError}
      onLoad={onLoaded}
      loading="lazy"
    />
  ) : (
    <img
      className={className}
      src={imageSrc ?? fallback ?? FALLBACK}
      alt={loaded ? alt ?? "" : ""}
      style={style}
      onError={onError}
      onLoad={onLoaded}
    />
  );
};
